import {
    Col,
    Grid,
    Menu,
    MenuProps, Row, theme,
} from 'antd';
import { useMemo } from 'react';
import {
    useLocation, useNavigate,
} from 'react-router-dom';

import { getHeaderNavItems } from '@/constants';
import { useUserStore } from '@/stores';

export const HeaderMenu = () => {
    const { user } = useUserStore();
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = theme.useToken();
    const screens = Grid.useBreakpoint();
    const isMobileNav = screens.lg === false;

    const items: MenuProps['items'] = useMemo(() => getHeaderNavItems(user?.role), [user?.role]);

    const handleMenuItemClick: MenuProps['onClick'] = (info) => {
        if (info.key !== 'external' && info.key !== 'SubMenu') {
            navigate(info.key);
        }
    };

    if (isMobileNav) {
        return null;
    }

    return (
        <div
            className="app-header-menu-row"
            style={{ paddingLeft: 16, paddingRight: 16, backgroundColor: token.colorBgContainer }}
        >
            <Row justify="space-between" align="middle">
                <Col flex="auto">
                    <Menu mode="horizontal" items={items} onClick={handleMenuItemClick} selectedKeys={[location.pathname]} />
                </Col>
            </Row>
        </div>
    );
};
